import { createIcon } from '../shared'

const LikeIcon = createIcon(
  ({ color }) => (
    <path
      d="M16.6973 5.50015C15.4753 5.44015 14.0183 6.01015 12.8073 7.66015L12.0023 8.75015L11.1963 7.66015C9.98431 6.01015 8.52631 5.44015 7.30431 5.50015C6.06131 5.57015 4.95531 6.28015 4.39431 7.41015C3.84231 8.53015 3.76131 10.1901 4.87331 12.2301C5.94731 14.2001 8.13031 16.5001 12.0023 18.8401C15.8723 16.5001 18.0543 14.2001 19.1283 12.2301C20.2393 10.1901 20.1583 8.53015 19.6053 7.41015C19.0443 6.28015 17.9393 5.57015 16.6973 5.50015ZM20.8843 13.1901C19.5333 15.6701 16.8833 18.3101 12.5053 20.8601L12.0023 21.1601L11.4983 20.8601C7.11931 18.3101 4.46931 15.6701 3.11631 13.1901C1.75631 10.6901 1.70631 8.33015 2.60231 6.52015C3.48931 4.73015 5.24931 3.61015 7.20331 3.51015C8.85431 3.42015 10.5713 4.07015 12.0013 5.52015C13.4303 4.07015 15.1473 3.42015 16.7973 3.51015C18.7513 3.61015 20.5113 4.73015 21.3983 6.52015C22.2943 8.33015 22.2443 10.6901 20.8843 13.1901Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'TwitterLikeIcon',
)

export { LikeIcon }
